@if (needChooseProduct()) {
  <beautyapp-choose-product
    (productSelected)="chooseProduct($event)"
  ></beautyapp-choose-product>
} @else {
  <form [formGroup]="form" class="flex justify-between gap-6">
    <div class=" flex-1 flex flex-col gap-1">
      <div class="flex justify-between items-center gap-2 border-b border-gray-200 text-lg">
        <div>სახელი: </div>
        <div>{{product()?.name}}</div>
      </div>
      <div class="flex justify-between items-center gap-2 border-b border-gray-200 text-lg">
        <div>ბარკოდი: </div>
        <div>{{product()?.barcode}}</div>
      </div>
      <div class="flex justify-between items-center gap-2 border-b border-gray-200 text-lg">
        <div>პროდუცტის კოდი: </div>
        <div>{{product()?.productCode}}</div>
      </div>
      <div class="flex  justify-between items-center gap-2 border-b border-gray-200 text-lg">
        <div>კატეგორია: </div>
        <div>{{product()?.productCategory?.name}}</div>
      </div>
      <div class="flex justify-between items-center gap-2 border-b border-gray-200 text-lg">
        <div>მომწოდებელი: </div>
        <div>{{product()?.distributor?.name}}</div>
      </div>
      <div class="flex justify-between items-center gap-2 border-b border-gray-200 text-lg">
        <div>ვარგისია: </div>
        <div>{{product()?.bestBefore | date: 'dd/MM/yyyy'}}</div>
      </div>
      <div class="flex justify-between items-center gap-2 border-b border-gray-200 text-lg">
        <div>გასაყიდი ფასი: </div>
        <div>{{product()?.salePricePerItem}} <i class="lari lari-c"></i></div>
      </div>

      <div class="flex justify-between items-center gap-2 border-b border-gray-200 text-lg">
        <div>რაოდენობა: </div>
        <div>{{product()?.quantity}} ცალი</div>
      </div>
      <div class="flex justify-between items-center gap-2 border-b border-gray-200 text-lg">
        <div>ცალში გრამის ოდენობა: </div>
        <div>{{product()?.grPerItem}} გრამი/ცალში</div>
      </div>
      <div class="flex justify-between items-center gap-2 border-b border-gray-200 text-lg">
        <div>ჯამში გრამის ოდენობა: </div>
        <div>{{product()?.grSum}} გრამი</div>
      </div>

      <div class="pt-2">
        <button
          nz-button
          nzType="primary"
          (click)="needChooseProduct.set(true)"
        >
          <i nz-icon nzType="edit" nzTheme="outline"></i>
          შეცვლა
        </button>
      </div>
    </div>
    <div class="flex-1 flex flex-col gap-2">
      <div>
        <beautyapp-select
          formControlName="employeeId"
          [data]="visitAddFacade.employee$ | async"
          label="{{ 'calendar.form.employee' | translate }}"
          placeholder="{{ 'calendar.form.employee' | translate }}"
          valueMember="id"
          displayMember="fullName"
          required
          size="large"
        ></beautyapp-select>
      </div>

      <div class="flex gap-2 justify-between items-start">
        <ng-container *ngxPermissionsOnly="['field.employee_salary']">
          <div>
            <beautyapp-input
              label="{{'calendar.form.fixatedSalary' | translate}}"
              placeholder="{{'calendar.form.fixatedSalary' | translate}}"
              type="number"
              prefixIcon="dollar"
              formControlName="salaryFixed"
              size="large"
            ></beautyapp-input>
          </div>

          <div>
            <beautyapp-input
              label="{{'calendar.form.salary%' | translate}}"
              placeholder="{{'calendar.form.salary%' | translate}}"
              prefixIcon="percentage"
              type="number"
              formControlName="salaryPercent"
              [min]="0"
              [max]="100"
              [errors]="{ min: 'validators.percentRange', max: 'validators.percentRange' }"
              size="large"
            ></beautyapp-input>
          </div>
        </ng-container>
      </div>
      <div class="flex gap-2">
        <div style="width: 150px">
          <beautyapp-input
            label="{{'realization.gram' | translate}}"
            type="float"
            size="large"
            [nz-tooltip]="'მარაგი: ' + product().grSum + ' გრამი'"
            formControlName="gram"
          ></beautyapp-input>
        </div>
        <div style="width: 150px">
          <beautyapp-input
            label="{{'realization.quantity' | translate}}"
            type="float"
            size="large"
            [nz-tooltip]="'მარაგი: ' + product().quantity + ' ცალი'"
            formControlName="quantity"
          ></beautyapp-input>
        </div>
      </div>
      <div nz-col>
        <div nz-row nzFlex="initial">
          <nz-space>
            <div *nzSpaceItem style="width: 150px">
              <beautyapp-input
                label="{{'realization.price' | translate}}"
                type="number"
                size="large"
                formControlName="price"
                [readonly]="true"
              ></beautyapp-input>
            </div>
            <div *nzSpaceItem style="width: 150px">
              <beautyapp-input
                label="{{'realization.discount' | translate}}"
                type="number"
                size="large"
                suffixIcon="percentage"
                formControlName="discount"
                [disabled]="!form.get('price')?.value"
              ></beautyapp-input>
            </div>
            <div *nzSpaceItem style="width: 150px">
              <beautyapp-input
                label="{{'realization.withDiscount' | translate}}"
                type="float"
                size="large"
                formControlName="discountPrice"
                [disabled]="!form.get('price')?.value"
              ></beautyapp-input>
            </div>
          </nz-space>
        </div>
      </div>
      <div nz-col>
        <beautyapp-textarea
          formControlName="description"
          placeholder=""
          label="{{ 'calendar.form.comment' | translate }}"
          [rows]="5"
          [disabled]="visitAddFacade.isCompleted"
        ></beautyapp-textarea>
      </div>
    </div>

  </form>
}
<div *nzModalFooter class="flex">

  <div class="flex-1"></div>
  <div class="flex gap-2" style="padding-top: 25px">
    <button nz-button nzType="default" nzSize="large" (click)="modalRef.close()">{{ 'buttons.close' | translate }}
    </button>
    @if (!needChooseProduct()) {
      <button type="button" nz-button nzSize="large" nzType="primary"
              (click)="submit()">{{ 'buttons.save' | translate }}
      </button>
    }
  </div>
</div>

